import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=00a22ebe&scoped=true&"
import script from "./p01.vue?vue&type=script&lang=js&"
export * from "./p01.vue?vue&type=script&lang=js&"
import style0 from "./p01.vue?vue&type=style&index=0&id=00a22ebe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a22ebe",
  null
  
)

export default component.exports